import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

const SIZE = 12;

export const InfiniteScrollList = ({
  loadMoreCallBack,
  canLoadMore,
  loading,
  items,
  itemsWrapperClass,
  renderItemCallBack,
}) => {
  const [scrollThreshold, setScrollThreshold] = useState("150px");
  const scrollYCoordinate = useRef(0);

  useEffect(() => {
    setScrollThresholdByScreenHeight();

    window.onresize = () => {
      setScrollThresholdByScreenHeight();
    };
  }, []);

  const setScrollThresholdByScreenHeight = () => {
    let h = window.innerHeight;
    let r = window.innerWidth / window.innerHeight;

    if (r < 2) {
      setScrollThreshold("150px");
    } else if (h > 700 && h < 800) {
      setScrollThreshold("150px");
    } else if (h > 800 && h < 900) {
      setScrollThreshold("350px");
    } else if (h > 900 && h < 1100) {
      setScrollThreshold("450px");
    } else if (h > 1100) {
      setScrollThreshold("750px");
    }
  };
  return (
    <InfiniteScroll
      dataLength={items.length}
      next={() => {
        scrollYCoordinate.current = window.scrollY;
        loadMoreCallBack();
      }}
      hasMore={canLoadMore}
      scrollThreshold={scrollThreshold}
      loader={
        loading && (
          <div className={itemsWrapperClass}>
            {new Array(SIZE).fill(null).map((p, i) => renderItemCallBack(p, i))}
          </div>
        )
      }
    >
      <div className={itemsWrapperClass}>
        {items.map((project, i) => renderItemCallBack(project, i))}
      </div>
    </InfiniteScroll>
  );
};
